import React from 'react';
import NumerologyReportNav from './NumerologyReportNav';
import NumerologyReportBody from './NumerologyReportBody';
import NumerologyReportToolbar from './NumerologyReportToolbar';

export default function NumerologyReportView({ reportModel, summary }) {
  const sections =
    reportModel?.report?.sections ||
    reportModel?.contributions?.numerology?.report?.sections ||
    [];
  const ids = sections.map((s) => s.id);
  const ctx = reportModel?.reportContext;
  const sampleMode = ctx?.reportMode === 'sample';
  const hasSummarySection = sections.some((s) => s.id === 'summary');

  const headline = (() => {
    if (sampleMode && ctx?.sampleDisplayName) {
      return `Sample report · ${ctx.sampleDisplayName}`;
    }
    return 'Your personal numerology report';
  })();

  const modeLine = (() => {
    if (sampleMode) {
      return 'Sample · full-length demo · Personal Year uses the timing year shown in your chart';
    }
    return 'Personal numerology report — one complete written interpretation';
  })();

  return (
    <div className="amm-num-report amm-num-report-document">
      <aside className="amm-num-report-aside no-print">
        <NumerologyReportNav sectionIds={ids} />
      </aside>
      <div className="amm-num-report-main">
        <header className="amm-num-report-header amm-num-report-header--slim">
          <p className="amm-num-eyebrow">Astral Moon Magic · Numerology map</p>
          <h2 className="amm-num-h1">{headline}</h2>
          {sampleMode ? (
            <div className="amm-num-sample-ribbon" role="status">
              Illustrative sample — same engine as personal reports; not a historical verdict.
            </div>
          ) : null}
          <p className="amm-num-mode-line">{modeLine}</p>
          {summary && !hasSummarySection ? <p className="amm-num-lead">{summary}</p> : null}
          {!hasSummarySection ? (
            <p className="amm-num-meta">
              {reportModel?.bundle?.meta?.targetYear ? (
                <>
                  Timing year <strong>{reportModel.bundle.meta.targetYear}</strong>
                </>
              ) : null}
              {ctx?.profileKind ? (
                <>
                  {reportModel?.bundle?.meta?.targetYear ? ' · ' : null}
                  Profile: <strong>{ctx.profileKind.replace(/_/g, ' ')}</strong>
                </>
              ) : null}
            </p>
          ) : null}
        </header>

        <NumerologyReportToolbar reportModel={reportModel} summary={summary} />

        <NumerologyReportBody sections={sections} printMode={false} />
      </div>
    </div>
  );
}
